import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { localeService } from '../../../core';
import { restartCall } from '../../actions';
import { CallFrameVariant } from '../../constants';
import ParticipantPublisherErrorFull from './ParticipantPublisherErrorFull/ParticipantPublisherErrorFull';
import ParticipantPublisherErrorMini from './ParticipantPublisherErrorMini/ParticipantPublisherErrorMini';
import { isDoctor } from '../../helpers';
import { EndCallReasons } from '../../../../common/services/doxy-analytics/tracks/video-session-end';
export const ParticipantPublisherError = ({ stream, variant }) => {
    const dispatch = useDispatch();
    const restartCallHandle = useCallback(() => dispatch(restartCall(EndCallReasons.RESTART_FROM_PARTICIPANT_ERROR)), []);
    const personUsername = get(stream, 'personConnection.userName');
    const isOwnRoleDoctor = isDoctor();
    const miniMessage = localeService.formatMessageById('video-chat.publisher-error.video-unavailable');
    const fullMessage = localeService.formatMessageById('video-chat.publisher-error.stream-issue', { personUsername: personUsername });
    return variant === CallFrameVariant.Full
        ? <ParticipantPublisherErrorFull message={fullMessage}>
      {isOwnRoleDoctor
                ? <span className="text-medium">
            {localeService.formatMessageById("video-chat.publisher-error.if-the-problem-exists")}
              <button type="button" className="ui-button ui-button--flat--primary ui-button--small" onClick={restartCallHandle}>
              {localeService.formatMessageById("video-chat.publisher-error.try-restarting-the-call")}
            </button>
          </span>
                : null}
      </ParticipantPublisherErrorFull>
        : <ParticipantPublisherErrorMini message={miniMessage}/>;
};
